import { render, staticRenderFns } from "./HtColumn.vue?vue&type=template&id=6db34379&scoped=true&"
import script from "./HtColumn.vue?vue&type=script&lang=js&"
export * from "./HtColumn.vue?vue&type=script&lang=js&"
import style0 from "./HtColumn.vue?vue&type=style&index=0&id=6db34379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db34379",
  null
  
)

export default component.exports